module.exports = {"id":"18122","name":"Nicolas Penneteau","rating":"74","photo":"./data/images/photos/2/18122.png","club":{"name":"Sp. Charleroi","logo":"./data/images/clubs/Sp.Charleroi.png"},"positions":["G"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/NicolasPenneteau0.json
// module id = 3208
// module chunks = 0